import styled from 'styled-components';
import { LogoType } from './Logo';

export const LogoImage = styled.img<LogoType>`
	width: ${(props) => (props.noText ? `40px` : `132px`)};
	height: 100%;
	object-fit: contain;
`;
